import { Env } from "@stencil/core";
import * as Rollbar from "rollbar/dist/rollbar.umd";

export const rollbar = new Rollbar.default({
  accessToken: Env.ROLLBAR_ACCESS_TOKEN,
  environment: Env.NODE_ENV,
  enabled: Env.NODE_ENV !== 'development',
  captureUncaught: false,
  captureUnhandledRejections: false,
  verbose: false,
  hostSafeList: ['customink.com'],
});
